/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class CampaignDialog extends NoboxEntityDialog<CampaignRow, any> {
        protected getFormKey() { return CampaignForm.formKey; }
        protected getIdProperty() { return CampaignRow.idProperty; }
        protected getLocalTextPrefix() { return CampaignRow.localTextPrefix; }
        protected getNameProperty() { return CampaignRow.nameProperty; }
        protected getService() { return CampaignService.baseUrl; }
        protected getDeletePermission() { return CampaignRow.deletePermission; }
        protected getInsertPermission() { return CampaignRow.insertPermission; }
        protected getUpdatePermission() { return CampaignRow.updatePermission; }

        private campaignResultGrid: CampaignCampaignResultGrid;

        private campaignDataPropertyGrid: Serenity.PropertyGrid;
        private campaignDataForm: CampaignDataForm;
        private campaignDataValidator: JQueryValidation.Validator;

        private btnMessageCount: number = 0;
        private btnActionCount: number = 0;
        private isReadonly: boolean = false;

        protected form = new CampaignForm(this.idPrefix);

        constructor(container?: JQuery) {
            super(container);
            this.form.BodyText.element.textileToolbar();
            let helpPopover = new HelpPopover(this.form, this.getPropertyItems(), "i-am-a-class").init();
            this.campaignResultGrid = new CampaignCampaignResultGrid(this.byId('CampaignCampaignResultGrid'));

            this.campaignDataPropertyGrid = new Serenity.PropertyGrid(this.byId("CampaignDataPropertyGrid"), {
                idPrefix: this.idPrefix + "_CampaignData_",
                items: Q.getForm(CampaignDataForm.formKey),
                useCategories: true
            });

            if (this.form.ChannelId.value == "19") {
                Serenity.EditorUtils.setRequired(this.form.Subject, true);
            } else {
                Serenity.EditorUtils.setRequired(this.form.Subject, false);
            }

            // this is just a helper to access editors if needed
            this.campaignDataForm = new CampaignDataForm(this.campaignDataPropertyGrid.get_idPrefix());

            // initialize validator for customer form
            this.campaignDataValidator = this.byId("CampaignDataForm").validate(Q.validateOptions({}));
            this.initBtnList();

            //this.campaignResultGrid.openDialogsAsPanel = true;
            this.form.ChannelId.change(() => {
                if (this.form.ChannelId.value == "19") {
                    Serenity.EditorUtils.setRequired(this.form.Subject, true);
                } else {
                    Serenity.EditorUtils.setRequired(this.form.Subject, false);
                }
                if (!Q.isEmptyOrNull(this.form.ChannelId.text)) {
                    this.form.ChannelNm.value = this.form.ChannelId.text;
                }
            });
            this.form.IsSchedule.change(() => {
                if (this.form.IsSchedule.value == true) {
                    Serenity.EditorUtils.setReadOnly(this.form.Schedule, false);
                    Serenity.EditorUtils.setRequired(this.form.Schedule, true);
                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.Schedule, true);
                    Serenity.EditorUtils.setRequired(this.form.Schedule, false);
                }
            });
            this.form.AccountIds.change(() => {
                var val = this.form.AccountIds.get_value();
                if (!Q.isEmptyOrNull(val)) {
                    this.form.Groups.customEqualityFilter = {
                        AccountIds: val
                    };
                } else {
                    this.form.Groups.customEqualityFilter = {
                        AccountIds: "kosong"
                    };
                }
            });
            this.form.BodyType.change(() => {
                var val = this.form.BodyType.get_value();
                if (!Q.isEmptyOrNull(val)) {
                    if (val == "0") {
                        //this.form.BodyHtml.getGridField().toggle(false);
                        this.form.Body.getGridField().toggle(false);
                        this.form.BodyText.getGridField().toggle(true);
                        //Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
                        Serenity.EditorUtils.setRequired(this.form.Body, false);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, true);

                        this.buttonMessage(1, false);
                        this.buttonMessage(2, false);
                        this.buttonMessage(3, false);

                        this.buttonAction(1, false);
                        this.buttonAction(2, false);

                        this.form.ListMessage.getGridField().toggle(false);
                    } else if (val == "1") {
                        //this.form.BodyHtml.getGridField().toggle(true);
                        this.form.Body.getGridField().toggle(true);
                        this.form.BodyText.getGridField().toggle(false);
                        //Serenity.EditorUtils.setRequired(this.form.BodyHtml, true);
                        Serenity.EditorUtils.setRequired(this.form.Body, true);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, false);

                        this.buttonMessage(1, false);
                        this.buttonMessage(2, false);
                        this.buttonMessage(3, false);

                        this.buttonAction(1, false);
                        this.buttonAction(2, false);

                        this.form.ListMessage.getGridField().toggle(false);
                    } else if (val == "2") {
                        //this.form.BodyHtml.getGridField().toggle(false);
                        this.form.Body.getGridField().toggle(false);
                        this.form.BodyText.getGridField().toggle(true);
                        //Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
                        Serenity.EditorUtils.setRequired(this.form.Body, false);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, true);

                        //this.buttonMessage(1, true);
                        //this.buttonMessage(2, false);
                        //this.buttonMessage(3, false);
                        //this.form.ButtonCreate.getGridField().toggle(true);
                        this.form.ButtonActCreate.getGridField().toggle(false);
                        this.btnMessageCount = this.btnMessageCount == 0 ? 1 : this.btnMessageCount;
                        for (var i = 1; i <= 3; i++) {
                            if (i <= this.btnMessageCount) {
                                this.buttonMessage(i, true);
                            } else {
                                this.buttonMessage(i, false);
                            }
                        }

                        this.buttonAction(1, false);
                        this.buttonAction(2, false);

                        this.form.ListMessage.getGridField().toggle(false);
                    } else if (val == "3") {
                        //this.form.BodyHtml.getGridField().toggle(false);
                        this.form.Body.getGridField().toggle(false);
                        this.form.BodyText.getGridField().toggle(true);
                        //Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
                        Serenity.EditorUtils.setRequired(this.form.Body, false);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, true);

                        this.buttonMessage(1, false);
                        this.buttonMessage(2, false);
                        this.buttonMessage(3, false);

                        this.btnActionCount = this.btnActionCount == 0 ? 1 : this.btnActionCount;
                        this.form.ButtonCreate.getGridField().toggle(false);
                        for (var i = 1; i <= 2; i++) {
                            if (i <= this.btnActionCount) {
                                this.buttonAction(i, true);
                            } else {
                                this.buttonAction(i, false);
                            }
                        }

                        this.form.ListMessage.getGridField().toggle(false);
                    } else if (val == "4") {
                        //this.form.BodyHtml.getGridField().toggle(false);
                        this.form.Body.getGridField().toggle(false);
                        this.form.BodyText.getGridField().toggle(true);
                        //Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
                        Serenity.EditorUtils.setRequired(this.form.Body, false);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, true);

                        this.buttonMessage(1, false);
                        this.buttonMessage(2, false);
                        this.buttonMessage(3, false);


                        this.buttonAction(1, false);
                        this.buttonAction(2, false);

                        this.form.ListMessage.getGridField().toggle(true);
                        this.viewBtnList();
                        
                    }
                }
            });


            this.form.ButtonCreate.element.find(".btn").on("click", () => {
                this.btnMessageCount++;
                this.buttonMessage(this.btnMessageCount, true);
            })

            this.form.ButtonActCreate.element.find(".btn").on("click", () => {
                this.btnActionCount++;
                this.buttonAction(this.btnActionCount, true);
            })

            this.form.ButtonActType.change(() => {
                var value = this.form.ButtonActType.value;
                if (value == "url") {
                    Serenity.EditorUtils.setValue(this.form.ButtonAct1Type, "call");
                    this.form.ButtonAct.element.attr("placeholder", "ex https://nobox.ai");
                    this.form.ButtonAct1.element.attr("placeholder", "ex 6282747687643");

                    this.form.ButtonActText.element.attr("placeholder", "ex Websites");
                    this.form.ButtonAct1Text.element.attr("placeholder", "ex Call Me");
                } else {
                    Serenity.EditorUtils.setValue(this.form.ButtonAct1Type, "url");
                    this.form.ButtonAct1.element.attr("placeholder", "ex https://nobox.ai");
                    this.form.ButtonAct.element.attr("placeholder", "ex 6282747687643");

                    this.form.ButtonAct1Text.element.attr("placeholder", "ex Websites");
                    this.form.ButtonActText.element.attr("placeholder", "ex Call Me");
                }
            });

            this.form.ButtonAct1Type.change(() => {
                var value = this.form.ButtonAct1Type.value;
                if (value == "url") {
                    Serenity.EditorUtils.setValue(this.form.ButtonActType, "call");
                    this.form.ButtonAct1.element.attr("placeholder", "ex https://nobox.ai");
                    this.form.ButtonAct.element.attr("placeholder", "ex 6282747687643");

                    this.form.ButtonAct1Text.element.attr("placeholder", "ex Websites");
                    this.form.ButtonActText.element.attr("placeholder", "ex Call Me");
                } else {
                    Serenity.EditorUtils.setValue(this.form.ButtonActType, "url");
                    this.form.ButtonAct.element.attr("placeholder", "ex https://nobox.ai");
                    this.form.ButtonAct1.element.attr("placeholder", "ex 6282747687643");

                    this.form.ButtonActText.element.attr("placeholder", "ex Websites");
                    this.form.ButtonAct1Text.element.attr("placeholder", "ex Call Me");
                }
            });
            this.buttonMessageClose();
            this.buttonActionClose();

            this.campaignResultGrid.gmFun = () => {
                if (this.campaignResultGrid.getItems().length == 0) {
                    Serenity.EditorUtils.setValue(this.form.GenerateMessage, 1);
                    var callback = (res) => {
                        Serenity.EditorUtils.setValue(this.form.GenerateMessage, 0);
                        Q.notifySuccess("Success generate messages");
                        this.loadById(this.get_entityId());
                    }
                    super.save(callback)
                } else {
                    Q.confirm("Do you want generate new messages?", () => {
                        Serenity.EditorUtils.setValue(this.form.GenerateMessage, 1);
                        var callback = (res) => {
                            Serenity.EditorUtils.setValue(this.form.GenerateMessage, 0);
                            Q.notifySuccess("Success generate messages");
                            this.loadById(this.get_entityId());
                        }
                        super.save(callback)
                    });
                }
            }

            $(".tt-button-template").on("click", () => {
                var dlg = new CampaignSelectTemplateDialog();
                dlg.setTemplate = (res) => { this.setFromTemplate(res) };
                dlg.dialogOpen();
            });
            var initFile = false;
            this.form.Attachment.element.parent().find("ul").on("DOMNodeInserted", function () {
                if (initFile == false) {
                    initFile = true;
                    $('ul li.file-item.file-image').each(function () {
                        var elIMage = $(this).find(".thumb ");
                        $(this).find(".thumb ").removeAttr("style");
                        $(this).find(".thumb ").css("overflow", "hidden");
                        var image = elIMage.attr("href");
                        elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                    });
                    initFile = false;
                }
            });

            var pageX;
            var pageY;
            $("body").find("ul.tools").remove();
            $("body").append(`<ul class="tools">
                <li title="Italic selected text"><i class="fa fa-italic"></i></li>
                <li title="Bold selected text"><i class="fa fa-bold"></i></li>
                <li title="Strikethrough selected text"><i class="fa fa-strikethrough"></i></li>
                <li title="Monospace selected text">M</li>
            </ul>`);

            $("ul.tools li").eq(0).click(() => {
                this.setCharSelected(this.form.BodyText.element, '_');
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                }
            });
            $("ul.tools li").eq(1).click(() => {
                this.setCharSelected(this.form.BodyText.element, '*');
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                }
            });
            $("ul.tools li").eq(2).click(() => {
                this.setCharSelected(this.form.BodyText.element, '~');
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                }
            });
            $("ul.tools li").eq(3).click(() => {
                this.setCharSelected(this.form.BodyText.element, '```');
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                }
            });
            this.form.BodyText.element.bind("mouseup", () => {
                var selectedText = this.getSelected(this.form.BodyText.element);
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                } else {
                    if (selectedText != '') {
                        $('ul.tools').css({
                            'left': pageX + 5,
                            'top': pageY - 55
                        }).fadeIn(200);
                    } else {
                        $('ul.tools').fadeOut(200);
                    }
                }
            });
            this.form.BodyText.element.on("mousedown", function (e) {
                pageX = e.pageX;
                pageY = e.pageY;
            });

            this.form.IsPerContact.change(() => {
                this.checkIsPerContact();
            });
        }

        viewBtnList() {
            if (Q.isEmptyOrNull(this.form.InteractiveMsg.value)) {
                this.form.ListMessage.getGridField().find(".btn-list-edit").hide();
                this.form.ListMessage.getGridField().find(".btn-list-add").show();
            } else {
                var arr = JSON.parse(this.form.InteractiveMsg.value);
                if (arr[0].rows != undefined) {
                    this.form.ListMessage.getGridField().find(".btn-list-edit").show();
                    this.form.ListMessage.getGridField().find(".btn-list-add").hide();
                } else {
                    this.form.ListMessage.getGridField().find(".btn-list-edit").hide();
                    this.form.ListMessage.getGridField().find(".btn-list-add").show();
                }
            }
        }

        initBtnList() {
            this.form.ListMessage.getGridField().find(".btn-list-add").on("click", () => {
                var dlg = new CampaignListMessageDialog();
                dlg.saveCallback = (res) => {
                    this.form.InteractiveMsg.value = res;
                    this.viewBtnList();
                }
                dlg.loadNewAndOpenDialog();
            });
            this.form.ListMessage.getGridField().find(".btn-list-edit").on("click", () => {
                var dlg = new CampaignListMessageDialog();
                dlg.setEditMode(this.form.InteractiveMsg.value);
                dlg.saveCallback = (res) => {
                    this.form.InteractiveMsg.value = res;
                }
                dlg.loadNewAndOpenDialog();
            });
            this.form.ListMessage.getGridField().find(".btn-list-view").on("click", () => {

            });
        }

        checkIsPerContact() {
            var val = this.form.IsPerContact.value;
            if (val == true) {
                Serenity.EditorUtils.setRequired(this.campaignDataForm.DataExcel, true);
            } else {
                Serenity.EditorUtils.setRequired(this.campaignDataForm.DataExcel, false);
            }
        }

        getSelected(textArea) {
            var text = textArea[0].value;
            var indexStart = textArea[0].selectionStart;
            var indexEnd = textArea[0].selectionEnd;
            return text.substring(indexStart, indexEnd);
        }

        setCharSelected(textArea, char) {
            var text = textArea[0].value;
            var indexStart = textArea[0].selectionStart;
            var indexEnd = textArea[0].selectionEnd;
            var text1 = this.addStr(text, indexStart, char);
            var text2 = this.addStr(text1, indexEnd + char.length, char);
            textArea[0].value = text2;
        }

        addStr(str, index, stringToAdd) {
            return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
        }
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts[1] == undefined || parts[1] == "" || parts[1] == null) {
                if (name == "Channel") {
                    return 1;
                } else if (name == "Accounts") {
                    return "";
                }
            } else {
                return parts[1].split(';').shift();
            }
        }

        public setFromTemplate(res) {
            var item = res as CampaignTemplateRow;
            if (Q.isEmptyOrNull(this.form.Name.value)) {
                Serenity.EditorUtils.setValue(this.form.Name, item.Name);
            }
            if (Q.isEmptyOrNull(this.form.ChannelId.value)) {
                Serenity.EditorUtils.setValue(this.form.ChannelId, item.ChannelId);
                Serenity.EditorUtils.setValue(this.form.ChannelNm, item.ChannelNm);
            }
            if (Q.isEmptyOrNull(this.form.Attachment.value.toString())) {
                Serenity.EditorUtils.setValue(this.form.Attachment, item.Attachment);
            }
            Serenity.EditorUtils.setValue(this.form.Subject, item.Subject);
            Serenity.EditorUtils.setValue(this.form.Body, item.Body);
            Serenity.EditorUtils.setValue(this.form.BodyType, item.BodyType);
            if (item.BodyType == BodyType.BodyTypeEnum.Text) {
                //this.form.BodyHtml.getGridField().toggle(false);
                this.form.Body.getGridField().toggle(false);
                this.form.BodyText.getGridField().toggle(true);
                this.form.BodyText.value = item.BodyText;
                Serenity.EditorUtils.setRequired(this.form.BodyText, true);
                //Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
                Serenity.EditorUtils.setRequired(this.form.Body, false);
            } else if (item.BodyType == BodyType.BodyTypeEnum.HTML) {
                //this.form.BodyHtml.getGridField().toggle(true);
                this.form.Body.getGridField().toggle(true);
                this.form.BodyText.getGridField().toggle(false);
                //this.form.BodyHtml.set_value(item.BodyHtml);
                this.form.Body.set_value(item.BodyHtml);
                //Serenity.EditorUtils.setRequired(this.form.BodyHtml, true);
                Serenity.EditorUtils.setRequired(this.form.Body, true);
                Serenity.EditorUtils.setRequired(this.form.BodyText, false);
            }

            if (item.BodyType == BodyType.BodyTypeEnum.QuickReply) {
                this.setButtonMessage(item.InteractiveMsg);

                for (var i = 1; i <= 3; i++) {
                    if (i <= this.btnMessageCount) {
                        this.buttonMessage(i, true);
                    } else {
                        this.buttonMessage(i, false);
                    }
                }
            }

            if (item.BodyType == BodyType.BodyTypeEnum.CallToAction) {
                this.setButtonAction(item.InteractiveMsg);
                for (var i = 1; i <= 2; i++) {
                    if (i <= this.btnActionCount) {
                        this.buttonAction(i, true);
                    } else {
                        this.buttonAction(i, false);
                    }
                }
            }

            if (item.BodyType == BodyType.BodyTypeEnum.List) {
                this.form.ListMessage.getGridField().toggle(true);
                this.viewBtnList();
            }
        }

        hideButton(cssClass, aktif) {
            this.element.find(`.${cssClass}`).first().toggle(aktif);
            this.element.find(`.${cssClass}`).first().parent().toggle(aktif);
        }

        getSaveEntity() {
            var resEntity = {} as CampaignRow;
            var entity = super.getSaveEntity() as any;
            resEntity = this.mappingEntity(entity);
            if (entity.BodyType == "2") {
                var buttons = [];
                for (var i = 1; i <= this.btnMessageCount; i++) {
                    var indexBtn = i - 1;
                    buttons.push({
                        buttonId: `id${i}`,
                        buttonText: {
                            displayText: entity[`Button${indexBtn == 0 ? "" : indexBtn}`]
                        },
                        type: 1
                    })
                }
                resEntity.InteractiveMsg = JSON.stringify(buttons);
            } else if (entity.BodyType == "3") {
                var buttons = [];
                for (var i = 1; i <= this.btnActionCount; i++) {
                    var indexBtn = i - 1;
                    var text = entity[`ButtonAct${indexBtn == 0 ? "" : indexBtn}Text`];
                    var value = entity[`ButtonAct${indexBtn == 0 ? "" : indexBtn}`];
                    var type = entity[`ButtonAct${indexBtn == 0 ? "" : indexBtn}Type`];
                    if (type == "url") {
                        buttons.push(this.urlBtn(i, text, value));
                    } else if (type == "call") {
                        buttons.push(this.callBtn(i, text, value));
                    }
                }
                resEntity.InteractiveMsg = JSON.stringify(buttons);
            } else {
            }
            return resEntity;
        }

        urlBtn(index, text, url) {
            var btn = { index: index, urlButton: { displayText: text, url: url } };
            return btn;
        }

        callBtn(index, text, phone) {
            var btn = { index: index, callButton: { displayText: text, phoneNumber: phone } };
            return btn;
        }

        mappingEntity(item: any): CampaignRow {
            var resEntity = {} as CampaignRow;

            resEntity.AccountIds = item.AccountIds;
            resEntity.Attachment = item.Attachment;
            resEntity.Body = item.Body;
            //resEntity.BodyHtml = item.BodyHtml;
            resEntity.BodyText = item.BodyText;
            resEntity.BodyType = item.BodyType;
            resEntity.ChannelId = item.ChannelId;
            resEntity.ChannelNm = item.ChannelNm;
            resEntity.ColumnExcel = item.ColumnExcel;
            resEntity.DataExcel = item.DataExcel;
            resEntity.DataLookupBy = item.DataLookupBy;
            resEntity.Desc = item.Desc;
            resEntity.End = item.End;
            resEntity.PerDay = item.PerDay;
            resEntity.GenerateMessage = item.GenerateMessage;
            resEntity.Id = item.Id;
            resEntity.InteractiveMsg = item.InteractiveMsg;
            resEntity.IsPerContact = item.IsPerContact;
            resEntity.IsSchedule = item.IsSchedule;
            resEntity.ListIds = item.ListIds;
            resEntity.Name = item.Name;
            resEntity.Schedule = item.Schedule;
            resEntity.ShortLink = item.ShortLink;
            resEntity.Start = item.Start;
            resEntity.Status = item.Status;
            resEntity.Subject = item.Subject;
            resEntity.Tags = item.Tags;
            resEntity.Groups = item.Groups;
            resEntity.DvsId = item.DvsId;

            return resEntity;
        }

        setButtonMessage(json) {
            var button = JSON.parse(json) as [{
                buttonId: string,
                buttonText: {
                    displayText: string,
                }
                type: number
            }];
            this.btnMessageCount = button.length;
            button.forEach((x, i) => {
                this.form[`Button${i == 0 ? "" : i}`].value = x.buttonText.displayText;
            });
        }

        setButtonAction(json) {
            var button = JSON.parse(json) as [];
            this.btnActionCount = button.length;
            button.forEach((x, i) => {
                var text = this.form[`ButtonAct${i == 0 ? "" : i}Text`];
                var value = this.form[`ButtonAct${i == 0 ? "" : i}`];
                var type = this.form[`ButtonAct${i == 0 ? "" : i}Type`];
                if (x["callButton"] != undefined) {
                    Serenity.EditorUtils.setValue(type, "call");
                    text.value = x["callButton"]["displayText"];
                    value.value = x["callButton"]["phoneNumber"];
                } else if (x["urlButton"] != undefined) {
                    Serenity.EditorUtils.setValue(type, "url");
                    text.value = x["urlButton"]["displayText"];
                    value.value = x["urlButton"]["url"];
                }
            });
        }

        setStatus(status) {
            this.element.find(".s-DialogToolbar.s-Serenity-Toolbar .status-link").remove();
            if (status == 1) {
                this.element.find(".s-DialogToolbar.s-Serenity-Toolbar").append(`<div class="status-link lkbadge-md lkbadge lkbadge-secondary lkbadge-dim" style="margin-left: auto;"><i class="icon fa fa-file-text pr-1"></i>DRAFT</div>`);
            } else if (status == 2) {
                this.element.find(".s-DialogToolbar.s-Serenity-Toolbar").append(`<div class="status-link lkbadge-md lkbadge lkbadge-warning lkbadge-dim" style="margin-left: auto;"><i class="icon fa fa-clock pr-1"></i>PROCESS</div>`);
            } else if (status == 3) {
                this.element.find(".s-DialogToolbar.s-Serenity-Toolbar").append(`<div class="status-link lkbadge-md lkbadge lkbadge-success lkbadge-dim" style="margin-left: auto;"><i class="icon fa fa-check pr-1"></i>DONE</div>`);
            } else {
                this.element.find(".s-DialogToolbar.s-Serenity-Toolbar").append(`<div class="status-link lkbadge-md lkbadge lkbadge-danger lkbadge-dim" style="margin-left: auto;"><i class="icon fa fa-close pr-1"></i>CANCELED</div>`);
            }
        }
        protected getCloningEntity() {
            var clone = super.getCloningEntity();

            clone.Status = 1;
            if (clone.BodyType == BodyType.BodyTypeEnum.Text) {
                clone.BodyText = clone.Body;
            } else {
                clone.Body = clone.Body;
            }
            clone.Attachment = null;
            clone.IsSchedule = 0;
            clone.Schedule = null;
            clone.DataExcel = null;
            return clone;
        }

        buttonMessage(number: number, hidden: boolean) {
            if (hidden) {
                this.form.ButtonActCreate.getGridField().toggle(false);

                this.form.ButtonAct.getGridField().toggle(false);
                this.form.ButtonActClose.getGridField().toggle(false);
                this.form.ButtonActText.getGridField().toggle(false);
                this.form.ButtonActType.getGridField().toggle(false);
                Serenity.EditorUtils.setRequired(this.form.ButtonActType, false);
                Serenity.EditorUtils.setRequired(this.form.ButtonActText, false);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct, false);

                this.form.ButtonAct1.getGridField().toggle(false);
                this.form.ButtonAct1Close.getGridField().toggle(false);
                this.form.ButtonAct1Text.getGridField().toggle(false);
                this.form.ButtonAct1Type.getGridField().toggle(false);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1Type, false);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1Text, false);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1, false);
            }

            if (number == 1) {
                //this.btnMessageCount = hidden ? 1 : 0;
                this.form.ButtonCreate.getGridField().toggle(hidden);

                this.form.Button.getGridField().toggle(hidden);
                this.form.ButtonClose.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.Button, hidden);
            } else if (number == 2) {
                this.form.Button1Close.getGridField().toggle(hidden);
                this.form.Button1.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.Button1, hidden);
            } else if (number == 3) {
                if (this.form.BodyType.value == "2") {
                    this.form.ButtonCreate.getGridField().toggle(!hidden);
                }
                if (hidden) {
                    this.form.Button1CloseHide.getGridField().toggle(hidden);
                    this.form.Button1Close.getGridField().toggle(!hidden);
                } else {
                    if (this.btnMessageCount == 3) {
                        this.form.Button1CloseHide.getGridField().toggle(hidden);
                        this.form.Button1Close.getGridField().toggle(!hidden);
                    }
                }

                this.form.Button2.getGridField().toggle(hidden);
                this.form.Button2Close.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.Button2, hidden);
            }
        }

        buttonMessageClose() {
            this.form.Button1Close.element.on("click", () => {
                this.buttonMessage(this.btnMessageCount, false);
                this.btnMessageCount--;
            })
            this.form.Button2Close.element.on("click", () => {
                this.buttonMessage(this.btnMessageCount, false);
                this.btnMessageCount--;
            })
        }

        buttonActionClose() {
            this.form.ButtonAct1Close.element.on("click", () => {
                this.buttonAction(this.btnActionCount, false);
                this.btnActionCount--;
            })
        }

        buttonAction(number: number, hidden: boolean) {
            if (hidden) {
                this.form.ButtonCreate.getGridField().toggle(false);
                this.form.Button.getGridField().toggle(false);
                this.form.ButtonClose.getGridField().toggle(false);

                this.form.Button1Close.getGridField().toggle(false);
                this.form.Button1.getGridField().toggle(false);

                this.form.Button2.getGridField().toggle(false);
                this.form.Button2Close.getGridField().toggle(false);

                Serenity.EditorUtils.setRequired(this.form.Button, false);
                Serenity.EditorUtils.setRequired(this.form.Button1, false);
                Serenity.EditorUtils.setRequired(this.form.Button2, false);
            }
            if (number == 1) {
                //this.btnActionCount = hidden ? 1 : 0;
                this.form.ButtonActCreate.getGridField().toggle(hidden);

                this.form.ButtonAct.getGridField().toggle(hidden);
                this.form.ButtonActClose.getGridField().toggle(hidden);
                this.form.ButtonActText.getGridField().toggle(hidden);
                this.form.ButtonActType.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonActType, hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonActText, hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct, hidden);
            } else if (number == 2) {
                if (this.form.BodyType.value == "3") {
                    this.form.ButtonActCreate.getGridField().toggle(!hidden);
                }

                this.form.ButtonAct1.getGridField().toggle(hidden);
                this.form.ButtonAct1Close.getGridField().toggle(hidden);
                this.form.ButtonAct1Text.getGridField().toggle(hidden);
                this.form.ButtonAct1Type.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1Type, hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1Text, hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1, hidden);
            }
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();
            buttons.push({
                title: "Process",
                hint: "Process this campaign",
                separator: true,
                visible: false,
                cssClass: "btn-process",
                icon: "fa fa-clock text-warning",
                onClick: () => {
                    Q.confirm("Are you sure to process this campaign?", () => {
                        Serenity.EditorUtils.setValue(this.form.Status, 2);
                        Q.serviceCall({
                            blockUI: false,
                            url: "/Services/Nobox/Campaign/RabbitMQQueue",
                            request: {
                                EntityId: this.get_entityId(),
                                Entity: this.getSaveEntity()
                            },
                            onSuccess: (res) => {
                                this.applyChangesButton.click();
                            },
                            onError: (err) => {
                                if (err == null || err == undefined) {

                                } else {
                                    if (err.Error == null || err.Error == undefined) {

                                    } else {
                                        if (err.Error.Message == null || err.Error.Message == undefined) {

                                        } else {
                                            Q.alert(err.Error.Message);
                                        }
                                    }
                                }
                            }
                        });
                    });
                }
            });
            buttons.push({
                title: "Done",
                hint: "mark as done this campaign",
                separator: true,
                visible: false,
                cssClass: "btn-done",
                icon: "fa fa-check text-success",
                onClick: () => {
                    Q.confirm("Mark as done this campaign?", () => {
                        Serenity.EditorUtils.setValue(this.form.Status, 3);
                        this.applyChangesButton.click();
                        //Q.serviceCall({
                        //    blockUI: false,
                        //    url: "/Services/Nobox/Campaign/RabbitMQQueue",
                        //    request: {
                        //        EntityId: this.get_entityId(),
                        //        Entity: this.getSaveEntity()
                        //    },
                        //    onSuccess: (res) => {
                        //        this.applyChangesButton.click();
                        //    },
                        //    onError: (err) => {
                        //        console.log(err);
                        //    }
                        //});
                    });
                }
            });
            buttons.push({
                title: "Draft",
                hint: "Set status to draft",
                separator: true,
                visible: false,
                cssClass: "btn-draft",
                icon: "fa fa-file-text text-secondary",
                onClick: () => {
                    Q.confirm("Set to draft this campaign?", () => {
                        Serenity.EditorUtils.setValue(this.form.Status, 1);
                        this.applyChangesButton.click();
                        //Q.serviceCall({
                        //    blockUI: false,
                        //    url: "/Services/Nobox/Campaign/RabbitMQQueue",
                        //    request: {
                        //        EntityId: this.get_entityId(),
                        //        Entity: this.getSaveEntity()
                        //    },
                        //    onSuccess: (res) => {
                        //        this.applyChangesButton.click();
                        //    },
                        //    onError: (err) => {
                        //        console.log(err);
                        //    }
                        //});
                    });
                }
            });
            buttons.push({
                title: "Cancel",
                hint: "Cancel this campaign",
                separator: true,
                visible: false,
                cssClass: "btn-cancel",
                icon: "fa fa-close text-red",
                onClick: () => {
                    Q.confirm("Are you sure to cancel this campaign?", () => {
                        Serenity.EditorUtils.setValue(this.form.Status, 4);
                        this.applyChangesButton.click();
                        //Q.serviceCall({
                        //    blockUI: false,
                        //    url: "/Services/Nobox/Campaign/RabbitMQQueue",
                        //    request: {
                        //        EntityId: this.get_entityId(),
                        //        Entity: this.getSaveEntity()
                        //    },
                        //    onSuccess: (res) => {
                        //        this.applyChangesButton.click();
                        //    },
                        //    onError: (err) => {
                        //        console.log(err);
                        //    }
                        //});
                    });
                }
            });

            buttons.push({
                title: "Test Broadcast",
                hint: "Send Broadcast to this user",
                separator: true,
                visible: false,
                cssClass: "btn-testbroadcast",
                icon: "fa fa-scroll text-blue",
                onClick: () => {
                    if (this.validateForm()) {
                        Q.confirm("This broadcast will be send to this user email or phone number", () => {
                            Q.serviceCall({
                                blockUI: true,
                                url: "/Services/Nobox/Campaign/TestBroadcast",
                                request: {
                                    EntityId: this.get_entityId(),
                                    Entity: this.getSaveEntity()
                                },
                                onSuccess: (res) => {
                                    this.loadById(this.get_entityId());
                                },
                                onError: (err) => {
                                    console.log(err);
                                }
                            });
                        });
                    }
                }
            });

            //buttons.push({
            //    title: "Test SaveEntity",
            //    hint: "Send Broadcast to this user",
            //    separator: true,
            //    icon: "fa fa-star text-blue",
            //    onClick: () => {
            //        console.log(this.getSaveEntity(), "save entity");
            //    }
            //});
            return buttons;
        }

        protected updateInterface() {
            super.updateInterface();
            this.checkIsPerContact();
            //set default value channel dan account sesuai setting tenant
            if (this.isNew()) {
                var chId = this.getCookie("Channel");
                Serenity.EditorUtils.setValue(this.form.ChannelId, chId);
                Serenity.EditorUtils.setValue(this.form.AccountIds, this.getCookie("Accounts"));
            }

            var item = this.get_entity();
            if (item.PerDay == null) {
                this.form.PerDay.set_value("0");
            }
            var itemClone = this.getCloningEntity();
            this.campaignDataForm.DataExcel.element.find("ul").html(this.form.DataExcel.element.find("ul").html())
            this.campaignDataForm.DataExcel.value = this.form.DataExcel.value;
            this.campaignDataForm.DataLookupBy.set_value(this.form.DataLookupBy.value);
            if (this.isEditMode()) {

                this.form.Groups.customEqualityFilter = {
                    AccountIds: item.AccountIds
                };
                this.element.find(".btn-testbroadcast").toggle(true);
                if (item.BodyType == 0||item.BodyType == 2||item.BodyType == 3||item.BodyType == 4) {
                    //this.form.BodyHtml.getGridField().toggle(false);
                    this.form.Body.getGridField().toggle(false);
                    this.form.BodyText.getGridField().toggle(true);
                    this.form.BodyText.value = item.Body;
                    Serenity.EditorUtils.setRequired(this.form.BodyText, true);
                    //Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
                    Serenity.EditorUtils.setRequired(this.form.Body, false);
                } else if (item.BodyType == 1) {
                    //this.form.BodyHtml.getGridField().toggle(true);
                    this.form.Body.getGridField().toggle(true);
                    this.form.BodyText.getGridField().toggle(false);
                    //this.form.BodyHtml.set_value(item.Body);
                    this.form.Body.set_value(item.Body);
                    //this.form.BodyHtml.value = item.Body;
                    this.form.Body.value = item.Body;
                    //Serenity.EditorUtils.setRequired(this.form.BodyHtml, true);
                    Serenity.EditorUtils.setRequired(this.form.Body, true);
                    Serenity.EditorUtils.setRequired(this.form.BodyText, false);
                }
                this.setStatus(item.Status);

                if (item.Status == 1) {
                    this.hideButton("btn-cancel", true);
                    this.hideButton("btn-process", true);
                    this.hideButton("btn-done", false);
                    this.hideButton("btn-draft", false);
                    this.cloneButton.toggle(false);
                } else if (item.Status == 2) {
                    this.hideButton("btn-cancel", true);
                    this.hideButton("btn-process", false);
                    this.hideButton("btn-done", true);
                    this.hideButton("btn-draft", false);
                    this.cloneButton.toggle(false);
                } else if (item.Status == 3) {
                    this.hideButton("btn-cancel", false);
                    this.hideButton("btn-process", false);
                    this.hideButton("btn-done", false);
                    this.hideButton("btn-draft", false);
                    this.cloneButton.toggle(true);
                } else if (item.Status == 4) {
                    this.hideButton("btn-cancel", false);
                    this.hideButton("btn-process", false);
                    this.hideButton("btn-done", true);
                    this.hideButton("btn-draft", true);
                    this.cloneButton.toggle(false);
                }

                if (item.BodyType == BodyType.BodyTypeEnum.QuickReply) {
                    this.setButtonMessage(item.InteractiveMsg);

                    for (var i = 1; i <= 3; i++) {
                        if (i <= this.btnMessageCount) {
                            this.buttonMessage(i, true);
                        } else {
                            this.buttonMessage(i, false);
                        }
                    }
                }

                if (item.BodyType == BodyType.BodyTypeEnum.CallToAction) {
                    this.setButtonAction(item.InteractiveMsg);
                    for (var i = 1; i <= 2; i++) {
                        if (i <= this.btnActionCount) {
                            this.buttonAction(i, true);
                        } else {
                            this.buttonAction(i, false);
                        }
                    }
                }

                if (item.BodyType == BodyType.BodyTypeEnum.List) {
                    this.form.ListMessage.getGridField().toggle(true);
                    this.viewBtnList();
                }

                if (item.IsSchedule == 1) {
                    Serenity.EditorUtils.setReadOnly(this.form.Schedule, false);
                    Serenity.EditorUtils.setRequired(this.form.Schedule, true);
                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.Schedule, true);
                    Serenity.EditorUtils.setRequired(this.form.Schedule, false);
                }
            }
            this.campaignDataForm.ColumnExcel.set_value(item.ColumnExcel);
            if (this.isNewOrDeleted()) {
                if (itemClone.BodyType == 0 || itemClone.BodyType == 2 || itemClone.BodyType == 3 || itemClone.BodyType == 4) {
                    //this.form.BodyHtml.getGridField().toggle(false);
                    this.form.Body.getGridField().toggle(false);
                    this.form.BodyText.getGridField().toggle(true);
                    this.form.BodyText.value = itemClone.Body;
                    Serenity.EditorUtils.setRequired(this.form.BodyText, true);
                    //Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
                    Serenity.EditorUtils.setRequired(this.form.Body, false);
                } else if (itemClone.BodyType == 1) {
                    //this.form.BodyHtml.getGridField().toggle(true);
                    this.form.Body.getGridField().toggle(true);
                    this.form.BodyText.getGridField().toggle(false);
                    //this.form.BodyHtml.set_value(itemClone.Body);
                    this.form.Body.set_value(itemClone.Body);
                    //Serenity.EditorUtils.setRequired(this.form.BodyHtml, true);
                    Serenity.EditorUtils.setRequired(this.form.Body, true);
                    Serenity.EditorUtils.setRequired(this.form.BodyText, false);
                }
                this.setStatus(itemClone.Status);

                if (itemClone.BodyType == BodyType.BodyTypeEnum.QuickReply) {
                    this.setButtonMessage(itemClone.InteractiveMsg);

                    for (var i = 1; i <= 3; i++) {
                        if (i <= this.btnMessageCount) {
                            this.buttonMessage(i, true);
                        } else {
                            this.buttonMessage(i, false);
                        }
                    }
                }

                if (itemClone.BodyType == BodyType.BodyTypeEnum.CallToAction) {
                    this.setButtonAction(itemClone.InteractiveMsg);
                    for (var i = 1; i <= 2; i++) {
                        if (i <= this.btnActionCount) {
                            this.buttonAction(i, true);
                        } else {
                            this.buttonAction(i, false);
                        }
                    }
                }

                if (itemClone.BodyType == BodyType.BodyTypeEnum.List) {
                    this.form.ListMessage.getGridField().toggle(true);
                    this.viewBtnList();
                }

                if (itemClone.IsSchedule == 1) {
                    Serenity.EditorUtils.setReadOnly(this.form.Schedule, false);
                    Serenity.EditorUtils.setRequired(this.form.Schedule, true);
                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.Schedule, true);
                    Serenity.EditorUtils.setRequired(this.form.Schedule, false);
                }
            }
        }

        protected save(callback) {
            var val = this.form.BodyType.get_value();
            this.form.DataExcel.value = this.campaignDataForm.DataExcel.value;
            this.form.ColumnExcel.value = this.campaignDataForm.ColumnExcel.value;
            this.form.DataLookupBy.set_value(this.campaignDataForm.DataLookupBy.value);
            Serenity.EditorUtils.setValue(this.form.ChannelNm, this.form.ChannelId.text);
            var IsPerContact = this.form.IsPerContact.value;
            if (IsPerContact == true && this.campaignDataForm.DataExcel.value == null) {
                Q.notifyError("Data Excel is Required");
            } else {
                if (Q.isEmptyOrNull(this.form.ListIds.value) && Q.isEmptyOrNull(this.form.Groups.value)) {
                    Q.notifyError("Please select target broadcast lists or group");
                } else {
                    super.save(callback);
                }
            }
        }

        loadEntity(entity: CampaignRow) {
            super.loadEntity(entity);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'CampaignResult', this.isNewOrDeleted());
            if (this.isEditMode()) {
                this.campaignResultGrid.campaignId = `${entity.Id}`;
            }
        }
        getTemplate() {
            return `<div id="~_Tabs" class="s-DialogContent">
                        <ul>
                            <li><a href="#~_TabCampaign"><span>Campaign</span></a></li>
                            <li><a href="#~_TabData"><span>Data Source</span></a></li>
                            <li><a href="#~_TabCampaignResult"><span>Broadcast Messages</span></a></li>
                        </ul>
                        <div id="~_TabCampaign" class="tab-pane s-TabCampaign">
                            <div id="~_Toolbar" class="s-DialogToolbar">
                            </div>
                            <div class="s-Form">
                                <form id="~_Form" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_PropertyGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div id="~_TabData" class="tab-pane s-TabData">
                            <div id="~_Toolbar" class="s-DialogToolbar">
                            </div>
                            <div class="s-Form">
                                <form id="~_CampaignDataForm" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_CampaignDataPropertyGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div id="~_TabCampaignResult" class="tab-pane s-TabCampaignResult">
                            <div id="~_CampaignCampaignResultGrid">
                            </div>
                        </div>
                    </div>`;
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.isReadonly == true) {
                Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                this.element.find('sup').hide();
                this.saveAndCloseButton.remove();
                this.applyChangesButton.remove();
                this.deleteButton.remove();
                if (this.isEditMode()) {
                    var entityType = super.getEntitySingular();

                    // get name field value of record this dialog edits
                    let name = this.getEntityNameFieldValue() || "";

                    // you could use format with a local text, but again demo...
                    this.dialogTitle = 'View ' + entityType + " (" + name + ")";
                }
            }
        }
    }
}